import getBestClass from './get-best-class';
import getTheBestClass from './get-the-best-class';
import isCssIdGood from './is-css-id-good';
import { remove, forEach } from 'lodash';

/**
New algorythm:

	ARRAY Selectors = EACH ELEMENT SELLECTORS [
		0 => ARRAY[
			'element' => a
			'id' => null
			'classes' => ARRAY [
				'site-title'
				...
			]
		 ]
	]

	For each element in the queue (from current <el> to the <body>) {

		Fill Selectors array

	}

	ARRAY SELETOR = [
		'final element' => ''
		'closest class' => ''
		'closest id' => ''
		'closes global id' => ''
	]

	For each in Selectors array {
		if ( item 0 ) {
			check if to use class or element name or both?
			Fill SELECTOR=>'final element'
		} else {

			if ( SELECTOR=>'closest class' NOT filled ) {
				IF current item has a class? {
					1) Select the best class
					2) Fill SELECTOR=>'closest class'
				} else {
					break -> next interation
				}
			} else if ( SELECTOR=>'closest id' NOT filled ) {
				IF current item has a id? {
					IF ( current id is good) {
						Fill SELECTOR=>'closest id'
					}
				} else {
					break -> next interation
				}
			} else if ( SELECTOR=>'global id' NOT filled ) {
				IF current item has a id? {
					IF ( current id is good for 'global id') {
						Fill SELECTOR=>'global id'
					}
				} else {
					break -> next interation
				}
			}

			}

			IF
		}
	}
 */

/**
 * Return CSS path to the selected element.
 * @param {DOM Element} element
 * @param {String} status – 'default', 'defaultNoCache', 'sharp' – select one only.
 */
export default function getSelector( element ) {
	let selector = []

	// Get all parent nodes of the given element:
	let tempEl = element
	const elsUpward = [] // All parent nodes.

	while ( tempEl ) {
		elsUpward.unshift( tempEl );
		tempEl = tempEl.parentNode;
	}

	// Remove <document>, <html> and <body> elements from the array of parents.
	remove( elsUpward, function( el ) {
		if (	el.nodeName == '#document' ||
				el.nodeName == 'HTML' ||
				el.nodeName == 'BODY' ) {
			return true // Remove element from the array.
		}
	} )

	// Need to invert array to start from selected element.
	elsUpward.reverse();

	forEach( elsUpward, function( el, key, collection ) {
		// 1. Fill 'final element' of the selector with .goodClass or tag name.
		if ( 0 === key ) {
			let selectedClass = false

			// If classes are available – select the best one.
			if ( el.classList.length ) {
				selectedClass = getTheBestClass( el.classList );
				selector[ 'final element' ] = '.' + selectedClass
			}
			// If no good class found, continue with tag name.
			if ( ! selectedClass ) {
				selector[ 'final element' ] = el.nodeName.toLowerCase()
			}
		}

		// 2. Process all the other elements.
		if ( 0 !== key ) {
			// 2.a - Find the closes class.
			if ( undefined === selector[ 'closest class' ] ) {
				let selectedClass = false

				// If classes are available – select the best one.
				if ( el.classList.length ) {
					selectedClass = getTheBestClass( el.classList );
				}
				// If no good class found, continue with tag name.
				if ( selectedClass ) {
					selector[ 'closest class' ] = '.' + selectedClass
				}
			}

			// 2.b - Find the closest valid id.
			if ( undefined === selector[ 'closest id' ] && el.id ) {

				// // console.log( "TEST ID:" ); // console.log( el.id );
				// Make sure id doesn't contain numbers.
				if ( isCssIdGood( el.id ) ) {
					// // console.log( "GOOD" );
					selector[ 'closest id' ] = '#' + el.id
				} else {
					// // console.log( "BAD" );
				}
			}

			// 2.c - Find the global id.
			if ( undefined === selector[ 'global id' ] && el.id ) {
				const preferedGlobalIds = [
					'page',
					'site'
				]

				forEach( preferedGlobalIds, function( item ) {
					// Test item agains regex.
					if ( item === el.id ) {
						selector[ 'global id' ] = '#' + el.id
						return false // Exit early.
					}
				} )
			}
		}
	} )

	if ( undefined !== selector[ 'final element' ] ) {
		let selectorString = ''

		if ( undefined !== selector[ 'global id' ] ) {
			selectorString = selector[ 'global id' ]
		}

		if ( undefined !== selector[ 'closest id' ] ) {
			selectorString = selectorString + ' ' + selector[ 'closest id' ]
		}

		if ( undefined !== selector[ 'closest class' ] ) {
			selectorString = selectorString + ' ' + selector[ 'closest class' ]
		}

		if ( undefined !== selector[ 'final element' ] ) {
			selectorString = selectorString + ' ' + selector[ 'final element' ]
		}

		selector = selectorString

	} else {
		selector = false
	}

	// Return result.
	return selector;
}

/**
 * Try to detect a Gutenberg block in current element
 * or among the parent. If found – assign it new custom class
 * to be used for styling. Also mark this block with
 * 'data-preferred-class' attribute.
 *
 * @param {Element} element Selected HTML element.
 * @param {String} classId Unique signature to use as part of the class name.
 * @return {String/false} Return class or false.
 */
export function setCustomClass( element, classId ) {
	let result = false;
	const classPrefix = 'styled-'
	const className = proposeClassName( element );
	const customClass = classPrefix + className + '-' + classId
	const cssClasses = element.getAttribute( 'class' );

	if ( 'BODY' === element.nodeName ) {
		return false
	}

	// Already has custom 'styled-' class.
	// No need to search anything. Just return.
	if ( null !== cssClasses && cssClasses.includes( 'styled-' ) ) {
		for ( let i = 0, l = element.classList.length; i < l; ++i ) {
			if ( /styled-[a-z0-9-_]+/g.test( element.classList[ i ] ) ) {
				element.setAttribute( 'data-preferred-class', element.classList[ i ] )
				result = element.classList[ i ]
				return result
				break;
			}
		}
	}

	if ( null !== cssClasses && cssClasses.includes('block-7') ) {
		element.classList.add(customClass)
		element.setAttribute('data-preferred-class', customClass)
		result = customClass
	} else {
		// Check parent.
		result =  setCustomClass( element.parentNode, classId )
	}

	return result
}

function proposeClassName( element ) {
	let className = 'block'

	if ( element.classList.contains('wp-block-button') ) {
		className = 'button'
	} else if ( element.classList.contains('wp-block-quote') ) {
		className = 'quote'
	} else if ( 'P' === element.nodeName ) {
		className = 'text'
	} else if ( 'H1' === element.nodeName ) {
		className = 'heading-1'
	} else if ( 'H2' === element.nodeName ) {
		className = 'heading-2'
	} else if ( 'H3' === element.nodeName ) {
		className = 'heading-3'
	} else if ( 'H4' === element.nodeName ) {
		className = 'heading-4'
	} else if ( 'H5' === element.nodeName ) {
		className = 'heading-5'
	} else if ( 'H6' === element.nodeName ) {
		className = 'heading-6'
	} else if ( 'UL' === element.nodeName || 'OL' === element.nodeName ) {
		className = 'list'
	}

	return className;
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-selector.js